anchor-radio {
  display: inline;
}

:host {
  --l-outer-circle-size: var(--p-size-dynamic-250);
  --l-inner-circle-size: 0.625rem;
  & > *,
  & > *::before,
  & > ::after {
    box-sizing: border-box;
  }
}

@mixin radio-before-elm {
  content: '';
  position: absolute;
  top: unset;
  left: 0;
  right: unset;
  bottom: 0;
  display: block;
  height: var(--p-size-static-025);
  width: 0;
  box-sizing: border-box;
  background: var(--s-color-cta-default);
  -webkit-transition: width 0.4s cubic-bezier(1, 0, 0, 1);
  -o-transition: width 0.4s cubic-bezier(1, 0, 0, 1);
  transition: width 0.4s cubic-bezier(1, 0, 0, 1);
}

.anchor-c-radio {
  display: inline-flex;
  position: relative;

  &::before {
    @include radio-before-elm();
  }

  &:hover {
    &::before {
      width: 100%;
    }
  }

  &:focus {
    outline: 0;

    &::before {
      width: 100%;
      background: var(--b-color-black);
    }

    input[type='radio'] {
      border-color: var(--b-color-black);
    }
  }

  label {
    display: grid;
    grid-template-columns: var(--l-outer-circle-size) auto;
    gap: var(--p-size-dynamic-150);
    font-family: inherit;
    font-size: var(--p-size-dynamic-200);
    line-height: var(--l-outer-circle-size);
    padding: var(--p-size-dynamic-150) 0;

    &:hover {
      cursor: pointer;
    }

    input[type='radio'] {
      /* Add if not using autoprefixer */
      -webkit-appearance: none;
      appearance: none;
      /* For iOS < 15 to remove gradient background */
      background-color: var(--b-color-white);
      /* Not removed via appearance */
      margin: 0;
      font: inherit;
      width: var(--l-outer-circle-size);
      height: var(--l-outer-circle-size);
      border: var(--p-size-static-0125) solid var(--s-color-border-default);
      border-radius: 50%;
      transform: translateY(0.075em);
      display: grid;
      place-content: center;

      &:hover {
        cursor: pointer;
      }

      &::before {
        content: '';
        width: var(--l-inner-circle-size);
        height: var(--l-inner-circle-size);
        border-radius: 50%;
        transform: scale(0);
        transition: 120ms transform ease-in-out;
        box-shadow: inset 1em 1em var(--s-color-cta-default); // This is the color for the colored of the checked radio button
      }

      &:checked::before {
        transform: scale(1);
      }

      &:hover {
        border-color: var(--b-color-black);
      }
    }
  }

  &--background {
    background: var(--b-color-white);
    color: var(--s-color-text-default);

    label {
      padding: var(--p-size-dynamic-150);
    }
  }

  &--disabled {
    &::before {
      display: none;
    }

    &:focus {
      outline: 0;

      &:before {
        display: none;
      }
    }

    label {
      &:hover {
        cursor: not-allowed;
      }

      input[type='radio'] {
        border-color: var(--s-color-border-form-disabled);
        background-color: var(--b-color-neutral-lighter);

        &:hover {
          cursor: not-allowed;
          border-color: var(--s-color-border-form-disabled);
        }
      }
    }
  }
}
